import React, { useEffect, useMemo, useRef, useState } from 'react'
import styles from './upload.jcss'
import translate from '../../../core/translate'
import EditText from '../../../blocks.simple/editText/editText'
import { cn } from 'ethcss'
import Button from '../../../blocks.simple/button/button'
import Dropdown from '../../../blocks.simple/dropdown/dropdown'
import { Typography } from '../../../atoms/Typography'
import Dropzone from 'react-dropzone'
import { IFirmwareUpload } from '../FirmwareListHooks'
import LoaderItem from 'blocks.app/loader/__item/loader__item'
import { WikiInfo } from 'blocks.simple/wikiInfo/WikiInfo'
import JSZip from 'jszip'
import { api } from '../../../core/api/ConnectionManager'
import { Radio } from '../../../atoms/Radio'
import Checkbox from '../../../blocks.simple/checkbox/checkbox'

interface Version {
    version: string
    id: number
    latestVersion: boolean
}

interface DistributiveVersionsResponse {
    distributives?: Version[]
}

const accept = (platform: string | null, isUploadClientApp?: boolean, packageType?: string) => {
    let accept: string = ''

    if (isUploadClientApp) {
        switch (platform) {
            case 'WINDOWS':
            case 'WINDOWS x32':
            case 'WINDOWS x64':
            case 'WINDOWS 7 x32':
            case 'WINDOWS 7 x64':
                packageType === 'update' ? (accept = '.zip') : (accept = '.exe')
                break
            case 'LINUX':
            case 'LINUX x32':
            case 'LINUX x64':
            case 'AstraLinux 1.7':
            case 'AstraLinux 1.8':
                accept = '.deb'
                break
            case 'RedOS 8':
                accept = '.rpm'
                break
            case 'IMAQLIQ G-Box S.100':
                packageType === 'update' ? (accept = '.zip') : (accept = '.img')
                break
            case 'COLOR E-PAPER':
                accept = '.zip'
                break
            case 'RASPBERRY':
            case 'RASPBERRY_V3 x32':
            case 'RASPBERRY_V3 x64':
            case 'RASPBERRY_V4 x32':
            case 'RASPBERRY_V4 x64':
            case 'Raspberry Pi 4 ARMx64':
                packageType === 'update' ? (accept = '.deb') : (accept = '.zip')
                break
            case 'ANDROID':
                accept = '.apk'
                break
            case 'ANDROID 4':
                accept = '.apk'
                break
            case 'BRIGHTSIGN':
                accept = '.zip'
                break
            case 'SSSP 2':
            case 'SSSP 3':
            case 'SSSP 4':
            case 'SSSP 5':
            case 'SSSP 6':
            case 'SSSP 7':
            case 'SSSP 10':
                accept = '.zip'
                break
            case 'WEBOS 2':
            case 'WEBOS 3':
            case 'WEBOS 3.2':
            case 'WEBOS 4':
            case 'WEBOS 4.1':
            case 'WEBOS 6':
            case 'WEBOS 9':
                accept = '.zip'
                break
        }
    } else {
        switch (platform) {
            case 'SSSP 2':
            case 'SSSP 3':
                accept = '.msd'
                break
            case 'SSSP 4':
            case 'SSSP 5':
            case 'SSSP 6':
            case 'SSSP 7':
            case 'SSSP 10':
            case 'TIZEN 7':
                accept = '.bem'
                break
            case 'WEBOS 2':
            case 'WEBOS 3':
            case 'WEBOS 3.2':
            case 'WEBOS 4':
            case 'WEBOS 4.1':
            case 'WEBOS 6':
            case 'WEBOS 9':
                accept = '.epk'
                break
            case 'ANDROID':
                accept = '.zip'
                break
            case 'BRIGHTSIGN':
                accept = '.bsfw'
                break
        }
    }

    return accept
}

const uploadClientAppPlatforms = [
    {
        id: 1,
        platform: 'ANDROID',
    },
    {
        id: 44,
        platform: 'ANDROID 4',
    },
    {
        id: 2,
        platform: 'BRIGHTSIGN',
    },
    {
        id: 7,
        platform: 'LINUX x32',
    },
    {
        id: 8,
        platform: 'LINUX x64',
    },
    {
        id: 37,
        platform: 'AstraLinux 1.7',
    },
    {
        id: 38,
        platform: 'AstraLinux 1.8',
    },
    {
        id: 41,
        platform: 'RedOS 8',
    },
    {
        id: 42,
        platform: 'IMAQLIQ G-Box S.100',
    },
    {
        id: 43,
        platform: 'COLOR E-PAPER',
    },
    {
        id: 9,
        platform: 'PROCENTRIC',
    },
    {
        id: 11,
        platform: 'RASPBERRY_V3 x32',
    },
    {
        id: 12,
        platform: 'RASPBERRY_V3 x64',
    },
    {
        id: 13,
        platform: 'RASPBERRY_V4 x32',
    },
    {
        id: 14,
        platform: 'RASPBERRY_V4 x64',
    },
    {
        id: 35,
        platform: 'Raspberry Pi 4 ARMx64',
    },
    {
        id: 15,
        platform: 'SSSP 2',
    },
    {
        id: 16,
        platform: 'SSSP 3',
    },
    {
        id: 17,
        platform: 'SSSP 4',
    },
    {
        id: 18,
        platform: 'SSSP 5',
    },
    {
        id: 19,
        platform: 'SSSP 6',
    },
    {
        id: 29,
        platform: 'SSSP 7',
    },
    {
        id: 30,
        platform: 'SSSP 10',
    },
    {
        id: 33,
        platform: 'TIZEN 7',
    },
    {
        id: 20,
        platform: 'WEBOS 2',
    },
    {
        id: 21,
        platform: 'WEBOS 3',
    },
    {
        id: 22,
        platform: 'WEBOS 3.2',
    },
    {
        id: 23,
        platform: 'WEBOS 4',
    },
    {
        id: 24,
        platform: 'WEBOS 4.1',
    },
    {
        id: 28,
        platform: 'WEBOS 6',
    },
    {
        id: 37,
        platform: 'WEBOS 9',
    },
    {
        id: 26,
        platform: 'WINDOWS x32',
    },
    {
        id: 27,
        platform: 'WINDOWS x64',
    },
    {
        id: 31,
        platform: 'WINDOWS 7 x32',
    },
    {
        id: 32,
        platform: 'WINDOWS 7 x64',
    },
]

const isAvailableTizenWebOSOption = (platform: string) => {
    const supportedPlatforms = [
        'SSSP 2',
        'SSSP 3',
        'SSSP 4',
        'SSSP 5',
        'SSSP 6',
        'SSSP 7',
        'SSSP 10',
        'TIZEN 7',
        'WEBOS 2',
        'WEBOS 3',
        'WEBOS 3.2',
        'WEBOS 4',
        'WEBOS 4.1',
        'WEBOS 6',
        'WEBOS 9',
    ]

    return supportedPlatforms.includes(platform)
}

const getBuildVersion = (value: unknown): string | null => {
    if (typeof value !== 'object' || value === null || !('VERSION' in value)) {
        return null
    }

    const version = (value as { VERSION?: unknown }).VERSION

    return typeof version === 'string' ? version : null
}

interface IUpload {
    onSave: (data: IFirmwareUpload) => void
    onClose: () => void
    isUploading: boolean
    isUploadClientApp?: boolean
}

export const Upload = ({ onSave, onClose, isUploading, isUploadClientApp }: IUpload) => {
    const [changeLatestVersion, setChangeLatestVersion] = useState<boolean>(false)
    const [version, setVersion] = useState<string>('')
    const [modelList, setModelList] = useState<{ name: string; label: string }[]>([])
    const [platform, setPlatform] = useState<string>('')
    const [versionsList, setVersionsList] = useState<Version[]>([])
    const [packageType, setPackageType] = useState<string>('distributive')
    const [packageDescription, setPackageDescription] = useState<string>('')
    const [firmwareFile, setFirmwareFile] = useState<File | null>(null)
    const [fileUrl, setFileUrl] = useState<string>('')
    const [orientation, setOrientation] = useState({ vertical: true, horizontal: true })
    const inputFileRef = useRef<HTMLInputElement | null>(null)

    const availablePackageType = [
        {
            id: 1,
            type: 'distributive',
        },
        {
            id: 2,
            type: 'update',
        },
    ]

    const availablePackageTypeTizenWebOS = [
        {
            id: 1,
            type: 'file',
        },
        {
            id: 2,
            type: 'fileLink',
        },
        {
            id: 3,
            type: 'versionSelect',
        },
    ]

    const getPackageTypesOptions = (platform: string) => {
        return isAvailableTizenWebOSOption(platform) ? availablePackageTypeTizenWebOS : availablePackageType
    }

    const availablePlatforms = useMemo(
        () =>
            isUploadClientApp
                ? uploadClientAppPlatforms
                : [
                      {
                          id: 1,
                          platform: 'SSSP 2',
                      },
                      {
                          id: 2,
                          platform: 'SSSP 3',
                      },
                      {
                          id: 3,
                          platform: 'SSSP 4',
                      },
                      {
                          id: 4,
                          platform: 'SSSP 5',
                      },
                      {
                          id: 5,
                          platform: 'SSSP 6',
                      },
                      {
                          id: 6,
                          platform: 'SSSP 7',
                      },
                      {
                          id: 7,
                          platform: 'SSSP 10',
                      },
                      {
                          id: 8,
                          platform: 'WEBOS 2',
                      },
                      {
                          id: 9,
                          platform: 'WEBOS 3',
                      },
                      {
                          id: 10,
                          platform: 'WEBOS 3.2',
                      },
                      {
                          id: 11,
                          platform: 'WEBOS 4',
                      },
                      {
                          id: 12,
                          platform: 'WEBOS 4.1',
                      },
                      {
                          id: 13,
                          platform: 'WEBOS 6',
                      },
                      {
                          id: 14,
                          platform: 'WEBOS 9',
                      },
                      {
                          id: 15,
                          platform: 'ANDROID',
                      },
                      {
                          id: 16,
                          platform: 'BRIGHTSIGN',
                      },
                      {
                          id: 17,
                          platform: 'TIZEN 7',
                      },
                  ],
        [isUploadClientApp]
    )

    const onOpenFilesClick = () => {
        if (inputFileRef.current) {
            inputFileRef.current.click()
        }
    }
    const onDrop = (filesList: File[]) => {
        if (filesList.length) {
            if (filesList[0].type === 'application/x-zip-compressed') {
                const jsZip = new JSZip()

                jsZip
                    .loadAsync(filesList[0])
                    .then((zip) => {
                        return zip.file('buildinfo.json')?.async('text')
                    })
                    .then((text: string | undefined) => {
                        if (text) {
                            const buildVersion = getBuildVersion(JSON.parse(text) as unknown)

                            if (buildVersion) {
                                setVersion(buildVersion)
                            }
                        }
                    })
            }

            const file = filesList[0]
            const extension = file.name.split('.').pop()

            if ('.' + extension === accept(platform, isUploadClientApp, packageType)) {
                setFirmwareFile(filesList[0])
                setFileUrl('')
            }
        }
    }
    const onPlatformChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value
        setPlatform(value)
        setFirmwareFile(null)
        if (inputFileRef.current) {
            inputFileRef.current.value = ''
        }
    }
    const onPackageTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value
        setPackageType(value)
        setFirmwareFile(null)
        if (inputFileRef.current) {
            inputFileRef.current.value = ''
        }
    }
    const isValid = () => {
        if (isUploadClientApp) {
            if (platform === 'SSSP 3') {
                if (!orientation.vertical && !orientation.horizontal) {
                    return false
                }
            }

            return Boolean(
                version &&
                    platform &&
                    (firmwareFile || fileUrl || packageType === 'versionSelect') &&
                    packageDescription
            )
        } else {
            return Boolean(version && modelList.length && platform && firmwareFile)
        }
    }

    const save = () => {
        const data: {
            platform: string
            version: string
            modelNameForUpdate: string[]
            file?: File
            packageType: string
            packageDescription: string
            fileUrl?: string
            distributiveId?: number
            changeLatestVersion?: boolean
            orientation?: { vertical: boolean; horizontal: boolean }
        } = {
            platform,
            version,
            modelNameForUpdate: modelList.map((option: { name: string; label: string }) => option.name),
            packageType,
            packageDescription,
        }

        if (fileUrl) {
            data.fileUrl = fileUrl
        }
        if (firmwareFile) {
            data.file = firmwareFile

            if (isUploadClientApp && isAvailableTizenWebOSOption(platform)) {
                data.changeLatestVersion = changeLatestVersion
            }
        }
        if (packageType === 'versionSelect') {
            const distributiveId = versionsList.find((item) => item.version === version)

            if (distributiveId && distributiveId.id) {
                data.distributiveId = distributiveId.id
            }
        }
        if (platform === 'SSSP 2' || platform === 'SSSP 3') {
            data.orientation = orientation
        }

        onSave(data)
    }

    useEffect(() => {
        if (isAvailableTizenWebOSOption(platform)) {
            setPackageType('file')
        } else {
            setPackageType('distributive')
        }

        setVersion('')
    }, [platform])

    useEffect(() => {
        if (isUploadClientApp && isAvailableTizenWebOSOption(platform)) {
            const platformOption = uploadClientAppPlatforms.find((item) => item.platform === platform)

            if (platformOption) {
                api.send<{ platformId: number }, DistributiveVersionsResponse>('getDistributiveVersions', {
                    platformId: platformOption.id,
                }).then((res) => {
                    if (res && res.distributives) {
                        setVersionsList(res.distributives)
                    }
                })
            }
        }
    }, [isUploadClientApp, platform])

    return (
        <div className={styles.wrapper}>
            <div className={styles.uploadModal}>
                {isUploading ? (
                    <div className={styles.loaderWrapper}>
                        <div className={styles.loader}>
                            <LoaderItem inv={true} />
                        </div>
                        <div>{translate(isUploadClientApp ? 'distributiveIsUploading' : 'firmwareIsUploading')}</div>
                    </div>
                ) : (
                    <>
                        <div className={styles.caption}>
                            <span>
                                {translate(isUploadClientApp ? 'uploadDistributionOnServer' : 'uploadFirmwareOnServer')}
                            </span>
                            <WikiInfo blockKey={'distributive'} blockSubKey={'downloadModal'} infoKey={'description'} />
                        </div>
                        <div className={styles.row}>
                            <label className={styles.label}>{translate('platform')}</label>
                            <select className={styles.select} onChange={onPlatformChange} value={platform}>
                                <option disabled value="">
                                    {translate('selectPlatform')}
                                </option>
                                {availablePlatforms.map((option: { id: number; platform: string }) => (
                                    <option key={option.id}>{option.platform}</option>
                                ))}
                            </select>
                        </div>
                        {isUploadClientApp && (
                            <>
                                <div className={styles.row}>
                                    <label className={styles.label}>{translate('uploadClientAppLoadType')}</label>
                                    <select
                                        className={styles.select}
                                        onChange={onPackageTypeChange}
                                        value={packageType}
                                    >
                                        {getPackageTypesOptions(platform).map(
                                            (option: { id: number; type: string }) => (
                                                <option key={option.id} value={option.type}>
                                                    {translate(option.type)}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </>
                        )}
                        {isUploadClientApp && isAvailableTizenWebOSOption(platform) && packageType === 'versionSelect' && (
                            <div className={styles.row}>
                                <label className={styles.label}>{translate('distributiveVersion')}</label>
                                <select
                                    className={styles.select}
                                    value={version}
                                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                        setVersion(e.target.value)
                                    }}
                                >
                                    <option value={''}>{translate('selectVersion')}</option>
                                    {versionsList.map(
                                        (option: { id: number; version: string; latestVersion: boolean }) => (
                                            <option key={option.id} value={option.version}>
                                                {translate(option.version)}{' '}
                                                {option.latestVersion ? translate('lastStableVersion') : ''}
                                            </option>
                                        )
                                    )}
                                </select>
                            </div>
                        )}
                        {packageType !== 'versionSelect' && (
                            <div className={styles.row}>
                                <EditText
                                    label={translate(isUploadClientApp ? 'distributiveVersion' : 'firmwareVersion')}
                                    onChange={(value: string) => setVersion(value)}
                                    type="text"
                                    placeholder={translate(
                                        isUploadClientApp ? 'enterDistributiveVersion' : 'enterFirmwareVersion'
                                    )}
                                    value={version}
                                    labelColor={'grey'}
                                    disabled={isUploadClientApp && packageType === 'file'}
                                />
                            </div>
                        )}
                        {isUploadClientApp && (
                            <div className={styles.row}>
                                <EditText
                                    label={translate('simpleDescription')}
                                    onChange={(value: string) => setPackageDescription(value)}
                                    type="text"
                                    placeholder={translate('enterDescription')}
                                    value={packageDescription}
                                    labelColor={'grey'}
                                />
                            </div>
                        )}
                        {isUploadClientApp && isAvailableTizenWebOSOption(platform) && packageType === 'fileLink' && (
                            <div className={styles.row}>
                                <EditText
                                    label={translate('distributiveFileUrl')}
                                    onChange={(value: string) => {
                                        if (firmwareFile) {
                                            setFirmwareFile(null)
                                        }

                                        setFileUrl(value)
                                        if (inputFileRef.current) {
                                            inputFileRef.current.value = ''
                                        }
                                    }}
                                    type="text"
                                    placeholder={translate('enterDistributiveFileUrl')}
                                    value={fileUrl}
                                    labelColor={'grey'}
                                />
                            </div>
                        )}
                        {(!isAvailableTizenWebOSOption(platform) || packageType === 'file') && (
                            <>
                                <div className={cn(styles.row, styles.uploadRow)}>
                                    <EditText
                                        label={translate(isUploadClientApp ? 'distributiveFile' : 'firmwareFile')}
                                        type="text"
                                        placeholder={translate(
                                            isUploadClientApp ? 'selectDistributiveFile' : 'selectFirmwareFile'
                                        )}
                                        value={firmwareFile ? firmwareFile.name : ''}
                                        className={styles.firmwareInput}
                                        disabled={true}
                                        labelColor={'grey'}
                                    />
                                    <Button
                                        mod={'fill'}
                                        className={styles.firmwareButton}
                                        onClick={() => {
                                            setFirmwareFile(null)
                                            if (inputFileRef.current) {
                                                inputFileRef.current.value = ''
                                            }
                                            onOpenFilesClick()
                                        }}
                                        disabled={!platform}
                                    >
                                        {translate('selectAction')}
                                    </Button>
                                </div>
                                {isAvailableTizenWebOSOption(platform) && (
                                    <>
                                        <Typography className={cn(styles.secondTitle)} type="title">
                                            {translate('replaceOnLastVersion')}
                                        </Typography>
                                        <div className={styles.radioWrapper}>
                                            <Radio
                                                className={styles.radio}
                                                onClick={function () {
                                                    setChangeLatestVersion(true)
                                                }}
                                                label={translate('yes')}
                                                selected={changeLatestVersion}
                                            />
                                            <Radio
                                                onClick={function () {
                                                    setChangeLatestVersion(false)
                                                }}
                                                label={translate('no')}
                                                selected={!changeLatestVersion}
                                            />
                                        </div>
                                    </>
                                )}
                                {(platform === 'SSSP 2' || platform === 'SSSP 3') && (
                                    <div>
                                        <Typography className={cn(styles.secondTitle)} type="title">
                                            {translate('orientation')}
                                        </Typography>
                                        <Checkbox
                                            label={translate('orientationH')}
                                            checked={orientation.horizontal}
                                            className={styles.checkbox}
                                            labelClassName={styles.labelClassName}
                                            onClick={() => {
                                                setOrientation({
                                                    ...orientation,
                                                    horizontal: !orientation.horizontal,
                                                })
                                            }}
                                        />
                                        <Checkbox
                                            label={translate('orientationV')}
                                            checked={orientation.vertical}
                                            className={styles.checkbox}
                                            labelClassName={styles.labelClassName}
                                            onClick={() => {
                                                setOrientation({
                                                    ...orientation,
                                                    vertical: !orientation.vertical,
                                                })
                                            }}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                        {!isUploadClientApp && (
                            <div>
                                <label className={styles.label}>{translate('supportModelsList')}</label>
                                <Dropdown
                                    className={styles.modelsInput}
                                    list={modelList}
                                    options={[]}
                                    searchable={true}
                                    multiselectItems={true}
                                    onChange={(elements) => {
                                        setModelList(elements)
                                    }}
                                />
                                <Typography className={styles.modelTip} type="text">
                                    {translate('addFirmwareModels')}
                                </Typography>
                            </div>
                        )}
                        <div className={styles.btnGroup}>
                            <Button mod={'withBorder'} className={styles.modalBtn} onClick={onClose}>
                                {translate('cancel')}
                            </Button>
                            <Button mod={'fill'} className={styles.modalBtn} onClick={save} disabled={!isValid()}>
                                {translate('upload')}
                            </Button>
                        </div>
                    </>
                )}
            </div>
            <Dropzone onDrop={onDrop}>
                {({ getRootProps, getInputProps }) => (
                    <div
                        {...getRootProps({
                            onClick: (event) => event.stopPropagation(),
                            className: cn(styles.dropzone),
                        })}
                    >
                        <input
                            {...getInputProps()}
                            type={'file'}
                            ref={inputFileRef}
                            multiple={false}
                            accept={accept(platform, isUploadClientApp, packageType)}
                        />
                    </div>
                )}
            </Dropzone>
        </div>
    )
}
